import React from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import { useBarChartStepperStyles } from '../../utils/styles.esm.js';

const BarChartSteps = ({
  steps,
  activeStep,
  onClick
}) => {
  const classes = useBarChartStepperStyles();
  const handleOnClick = (index) => (event) => {
    event.preventDefault();
    onClick(index);
  };
  return /* @__PURE__ */ React.createElement("div", { className: classes.steps }, [...new Array(steps)].map((_, index) => /* @__PURE__ */ React.createElement(ButtonBase, { key: index, centerRipple: true, onClick: handleOnClick(index) }, /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-testid": "bar-chart-step",
      className: `${classes.step} ${index === activeStep ? classes.stepActive : ""}`
    }
  ))));
};

export { BarChartSteps };
//# sourceMappingURL=BarChartSteps.esm.js.map
